<template>
  <div>
    <Row :gutter="16">
      <Col span="8">
        <Select :value="value.rule" @on-change="onInput({ rule: $event, op: '', value: '' })">
          <OptionGroup label="系统变量">
            <Option v-for="item in sysVars" :value="`sys:${item.id}`" :key="`sys:${item.id}`">{{
              item.name
            }}</Option>
          </OptionGroup>
          <OptionGroup label="意图">
            <Option v-for="item in intents" :value="`intent:${item.id}`" :key="`intent:${item.id}`">{{
              item.name
            }} 次数</Option>
          </OptionGroup>
          <OptionGroup label="自定义变量">
            <Option v-for="item in vars" :value="`var:${item.name}`" :key="`var:${item.name}`">{{
              item.name
            }}</Option>
          </OptionGroup>
        </Select>
      </Col>
      <Col span="6">
        <Select
          :value="value.op"
          @on-change="onInput({ ...value, op: $event })"
          v-if="value.rule"
        >
          <Option
            v-for="item in curOperator"
            :value="item.value"
            :key="item.value"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Col>
      <Col span="8">
        <Input
          v-if="value.rule"
          :value="value.value"
          @on-change="onInput({ ...value, value: $event.target.value })"
        />
      </Col>
      <Col span="2">
        <Icon
          class="var-del-icon"
          color="#ed4014"
          type="ios-trash-outline"
          @click="$emit('delete')"
        />
      </Col>
    </Row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        name: '',
        op: '',
        value: '',
      }),
    },
  },
  data() {
    return {
      operator: {
        gt: '大于',
        lt: '小于',
        gte: '大于等于',
        lte: '小于等于',
        equals: '等于',
        all: '包含所有',
        any: '包含任一',
      },
      type: {
        NUM: ['gt', 'lt', 'gte', 'lte', 'equals'],
        STR: ['equals', 'all', 'any'],
      },
    };
  },
  computed: {
    ...mapState('setting', ['vars', 'sysVars']),
    ...mapState('intents', [
			'intents'
    ]),
    curVal() {
      if (this.value.rule.indexOf('sys:') === 0) {
        return this.sysVars.find((item) => `sys:${item.id}` === this.value.rule) || {};
      } else if (this.value.rule.indexOf('intent') === 0) {
        return { type: 'NUM' }
      }
      return this.vars.find((item) => `var:${item.name}` === this.value.rule) || {};
    },
    // operator选项
    curOperator() {
      const type = this.curVal.type;
      if (!type) return [];
      return this.type[type]?.map((item) => ({
        label: this.operator[item],
        value: item,
      }));
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    }
  }
};
</script>